import { render, staticRenderFns } from "./register.page.vue?vue&type=template&id=30b613be&scoped=true&"
import script from "./register.page.vue?vue&type=script&lang=js&"
export * from "./register.page.vue?vue&type=script&lang=js&"
import style0 from "./register.page.vue?vue&type=style&index=0&id=30b613be&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30b613be",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VBtn,VForm})
